import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

function Stats() {
  const { t } = useTranslation();

  const [counters, setCounters] = useState({
    experience: 0,
    cases: 0,
    satisfaction: 0,
    response: 0,
  });

  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef(null);

  // Função para animar um contador específico
  const animateCounter = (start, end, duration, key) => {
    const startTime = performance.now();

    const updateCounter = currentTime => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Função de easing para suavizar a animação
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentValue = Math.floor(start + (end - start) * easeOutQuart);

      setCounters(prev => ({
        ...prev,
        [key]: currentValue,
      }));

      if (progress < 1) {
        requestAnimationFrame(updateCounter);
      }
    };

    requestAnimationFrame(updateCounter);
  };

  // Intersection Observer para detectar quando a seção de stats entra na tela
  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);

            // Animar cada contador com delays diferentes para um efeito escalonado
            setTimeout(() => animateCounter(0, 16, 2000, 'experience'), 200);
            setTimeout(() => animateCounter(0, 950, 2500, 'cases'), 200);
            setTimeout(() => animateCounter(0, 100, 2000, 'satisfaction'), 200);
            setTimeout(() => animateCounter(0, 24, 1800, 'response'), 200);
          }
        });
      },
      {
        threshold: 0.5,
      },
    );

    const statsNode = statsRef.current;
    if (statsNode) {
      observer.observe(statsNode);
    }

    return () => {
      if (statsNode) {
        observer.unobserve(statsNode);
      }
    };
  }, [hasAnimated]);

  return (
    <section className='stats' ref={statsRef}>
      <div className='stats-container'>
        <div className='stat-item'>
          <div className='stat-number'>{counters.experience}+</div>
          <div className='stat-label'>{t('stats_experience')}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-number'>{counters.cases}+</div>
          <div className='stat-label'>{t('stats_cases')}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-number'>{counters.satisfaction}%</div>
          <div className='stat-label'>{t('stats_satisfaction')}</div>
        </div>
        <div className='stat-item'>
          <div className='stat-number'>{counters.response}h</div>
          <div className='stat-label'>{t('stats_response')}</div>
        </div>
      </div>
    </section>
  );
}

export default Stats;
